import { Component } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ContentService, EventBusService, HelperService, UserService } from "@mypxplat/xplat/core";

import { LessonDetailBaseComponent } from "@mypxplat/xplat/features";
import { AppService } from "@mypxplat/xplat/web/core";
import { takeUntil } from "rxjs";

@Component({
  selector: "myp-lesson-detail",
  templateUrl: "lesson-detail.component.html",
  standalone: false,
})
export class LessonDetailComponent extends LessonDetailBaseComponent {
  public breadcrumbs: any[] = [];
  public loading: boolean;
  public loadingSaveLesson: boolean = false;
  constructor(
    userService: UserService,
    public contentService: ContentService,
    public activatedRoute: ActivatedRoute,
    public helperService: HelperService,
    public appService: AppService,
    public eventBusService: EventBusService,
    public router: Router
  ) {
    super(userService);
  }

  ngOnInit() {
    this.lessonId = this.activatedRoute.snapshot.params["id"];
    this.loading = true;
    this.init();
    this.eventBusService
      .observe(this.eventBusService.types.videoClosed)
      .pipe(takeUntil(this.destroy$))
      .subscribe((result) => {
        this.contentService.getEducationData().subscribe((result) => {
          this.init();
        });
      });
  }

  toggleSaveLesson(lesson: any) {
    this.loadingSaveLesson = true;
    this.contentService
      .saveUserLearnGroupData(lesson.id, {
        user_id: this.user.id,
        learn_group_id: lesson.id,
        enrolled: !this.contentService.userLearnData.lessons[lesson.id]?.enrolled,
      })
      .subscribe((result) => {
        this.init();
        this.loadingSaveLesson = false;
      });
  }

  init() {
    this.contentService.getEducationData().subscribe((result) => {
      this.lesson = this.contentService.lessonMap[this.lessonId];
      console.log(this.contentService.userLearnData.lessons[this.lesson.id]);
      this.loading = false;
      this.breadcrumbs = [
        { label: "header.nav.home", routerLink: ["/home"] },
        { label: "fui-header.learn", routerLink: ["/learn"] },
        { label: "education.lessons", routerLink: ["/learn/lessons"] },
        { label: this.lesson.title },
      ];
    });
  }

  pinLesson(enroll = true) {
    let args: any = {
      user_id: this.user.id,
      learn_group_id: this.lesson.id,
      enrolled: enroll,
      date_started: new Date(),
    };

    this.contentService.saveUserLearnGroupData(this.lesson.id, args).subscribe({
      next: (result) => {},
      error: (error) => {
        this.appService.alertError(error);
      },
    });
  }

  upgrade() {
    this.router.navigate(["/onboarding"], { queryParams: { subscribeOnly: true } });
  }
}
